import React, { createContext, ComponentType, useState, useMemo } from 'react';
import axios from 'axios';
import { useAlert, Localize, useTransformObject } from '@hilma/netina2all';

import { useI18n } from '../../hooks';

interface OrderSummaryContextValue {
    getOrderSummary: () => Promise<void>;
    orderDetails: OrderSummary | null;
    hideInfo: boolean;
}

interface OrderSummary {
    id: number;
    personalInfo: [string, string, string, string, string, string, string];
    items: {
        kits: Localize<{
            name: string;
            price: number;
            donationPercent: string;
            amount: number;
            description?: string;
            imagePath?: string;
        }>[],
        holders: number;
    };
    costs: [number, number, number, number, number] // fourSpecies, speciesDonation, atoneDonation, totalDonated, orderTotal
}

interface ChildrenProps {
    children: React.ReactNode;
}

export const OrderSummaryContext = createContext<OrderSummaryContextValue | null>(null)

export const OrderSummayProvider: ComponentType<ChildrenProps> = ({ children }) => {

    const [orderDetails, setOrderDetails] = useState<OrderSummary | null>(null);
    const transformObject = useTransformObject();
    const [hideInfo, setHideInfo] = useState(true);
    const errTexts = useI18n(i18n => i18n.errText);

    const alert = useAlert();

    const translatedOrderDetails = useMemo(() => {
        if (orderDetails !== null) {
            const object = {
                ...orderDetails!,
                items: {
                    ...orderDetails!.items,
                    kits: orderDetails!.items.kits.map(transformObject)
                }
            }
            return object as OrderSummary
        } else return null

    }, [transformObject, orderDetails]);

    const getOrderSummary = async () => {
        try {
            const res = await axios.get('/api/purchase/order-summary')
            setOrderDetails(res.data);
            setHideInfo(false);

        } catch (err: any) {
            alert(err?.data?.message === 'One or more of the selected products is unavailable' ? errTexts.unavailableKit : err.status === 403 ? errTexts.invalidInfo : err.data?.message === 'Please select a station' ? errTexts.selectAStation : errTexts.generalSystem);
            setHideInfo(true);
        }

    }

    return (
        <OrderSummaryContext.Provider value={{ getOrderSummary, orderDetails: translatedOrderDetails, hideInfo }}>
            {children}
        </OrderSummaryContext.Provider>
    )
}